import axios from 'axios'

export const FOREIGN_INCOME_UPDATE = 'FOREIGN_INCOME_UPDATE'
export const FOREIGN_INCOME_SAVING = 'FOREIGN_INCOME_SAVING'
export const FOREIGN_INCOME_SAVE_SUCCESS = 'FOREIGN_INCOME_SAVE_SUCCESS'
export const FOREIGN_INCOME_SAVE_ERROR = 'FOREIGN_INCOME_SAVE_ERROR'

export const getForeignIncomes = (taxReturnId) => (dispatch) => {
    axios
        .get(`/foreignIncomes?taxReturnId=${taxReturnId}`)
        .then((response) => {
            dispatch(
                updateForeignIncome({
                    shouldFetch: false,
                    fetchSuccessful: true,
                    taxReturnId,
                    foreignIncomes: response.data,
                })
            )
        })
        .catch(() => {})
}

export const updateForeignIncome = (foreignIncome) => ({
    type: FOREIGN_INCOME_UPDATE,
    foreignIncome,
})

export const addForeignIncome = (newForeignIncome) => (dispatch, getState) => {
    const { foreignIncome } = getState()

    foreignIncome.foreignIncomes.push(newForeignIncome)

    dispatch(updateForeignIncome(foreignIncome))
}

export const removeForeignIncome = (id) => (dispatch, getState) => {
    const { foreignIncome } = getState()

    const newForeignIncomes = foreignIncome.foreignIncomes.filter((o) => o.id !== id)

    dispatch(updateForeignIncome({ foreignIncomes: newForeignIncomes }))
}

export const deleteForeignIncome = (id) => (dispatch) => {
    axios
        .delete(`/foreignIncomes/${id}`)
        .then(() => {
            dispatch(removeForeignIncome(id))
        })
        .catch(() => {})
}

export const removeAndDeleteForeignIncome = (id) => (dispatch) => {
    dispatch(removeForeignIncome(id))
    dispatch(deleteForeignIncome(id))
}

export const saveForeignIncome = () => (dispatch, getState) => {
    const { foreignIncome } = getState()

    dispatch(foreignIncomeSaving, foreignIncome)

    axios
        .post('/foreignincomes/', foreignIncome.foreignIncomes)
        .then((response) => {
            dispatch(foreignIncomeSaveSuccess({ foreignIncomes: response.data }))
        })
        .catch((error) => {
            dispatch(foreignIncomeSaveError(foreignIncome, error.data))
        })
}

export const updateAndSaveForeignIncome = (foreignIncome) => (dispatch) => {
    dispatch(updateForeignIncome(foreignIncome))
    dispatch(saveForeignIncome())
}

export const foreignIncomeSaving = (foreignIncome) => ({
    type: FOREIGN_INCOME_SAVING,
    foreignIncome,
})

export const foreignIncomeSaveSuccess = (foreignIncome) => ({
    type: FOREIGN_INCOME_SAVE_SUCCESS,
    foreignIncome,
})

export const foreignIncomeSaveError = (foreignIncome, errorResponse) => ({
    type: FOREIGN_INCOME_SAVE_ERROR,
    foreignIncome,
    errorResponse,
})

export const saveForeignIncomeStatus = (data) => (dispatch, getState) => {
    const { foreignIncome } = getState()

    const { taxReturnId, foreignIncomeSummary } = foreignIncome

    axios
        .put(`/foreignincomesummary/${taxReturnId}`, {
            ...foreignIncomeSummary,
            taxReturnId,
            status: data.status,
        })
        .catch(() => {})
}

export const updateAndSaveForeignIncomeSummary = (data) => (dispatch) => {
    dispatch(updateForeignIncome({ foreignIncomeSummary: data }))
    dispatch(saveForeignIncomeSummary())
}

export const saveForeignIncomeSummary = () => (dispatch, getState) => {
    const { foreignIncome } = getState()

    const { taxReturnId, foreignIncomeSummary } = foreignIncome

    axios
        .put(`/foreignincomesummary/${taxReturnId}`, { ...foreignIncomeSummary, taxReturnId })
        .then((response) => {
            dispatch(foreignIncomeSaveSuccess({ foreignIncomeSummary: response.data }))
        })
        .catch((error) => {
            dispatch(foreignIncomeSaveError(foreignIncome, error.data))
        })
}

export const getForeignIncomeSummary = (taxReturnId) => (dispatch) => {
    axios
        .get(`/foreignincomesummary/${taxReturnId}`)
        .then((response) => {
            dispatch(updateForeignIncome({ foreignIncomeSummary: response.data }))
        })
        .catch(() => {})
}
